<template>
	<v-container>
		<v-dialog
		  v-model="parametros.estatus"
		  scrollable 
		  fullscreen 
		  persistent 
		>
			<v-card>
				<v-card-text>
				  <v-row justify="center">
				  	<!-- Información básica del grupo -->
				  	<v-col cols="12" class="pb-1">
				  		<v-card class="elevation-0 transparent">
				  			<v-card-text>
									<div class="mb-0 font-weight-bold text-h5 colorCurso text-center">
			              Ejercicio
			            </div>
				  			</v-card-text>
				  		</v-card>
				  	</v-col>
				  </v-row>

				  <v-row v-for="(pregunta, i ) in parametros.ejercicio" :key="i" justify="center">
				  	<v-col cols="12" sm="10" md="6" lg="6" >
				  		<v-card class="shadowCard px-0">
				  			<!-- Titulo -->
				  		  <v-card-title primary-title class="grey--text text-body-1">
				  		    Pregunta {{ pregunta.num_pregunta }}
				  		    <v-spacer></v-spacer>
				  		    Valor {{ pregunta.valor }}
				  		  </v-card-title>

				  		 	<v-img 
				  		  	v-if="pregunta.tiene_imagen == 1 && !pregunta.ruta_imagen.match('youtube')" 
				  		  	:src="pregunta.ruta + pregunta.ruta_imagen"
				  		 	></v-img>
				  		 
				  		 	<iframe
				  		  	v-if="pregunta.tiene_imagen == 1 && pregunta.ruta_imagen.match('youtube')" 
			            :src="pregunta.ruta_imagen"
			            width="100%" 
			            height="400"
			            frameborder="0"
			            class="pa-2"
			            allowfullscreen
			            allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture"
			          ></iframe>

			          <span
			          	v-if="pregunta.tiene_imagen == 1 && pregunta.ruta_imagen.match('youtube')" 
			          	class="text-h6 ml-4"
			          >
			          	{{ pregunta.pregunta }}
			        	</span>

				  		 	<!-- Agregar audio si es que tiene -->
				  		 	<div v-if="pregunta.tiene_audio_pregunta == 1" class="text-center mt-2 pb-0">
				  		 		<audio controls>
									  <source :src="pregunta.ruta + pregunta.ruta_audio_pregunta" type="audio/mpeg"></audio>
									</audio>
				  		 	</div>
				  		 	
				  		 	<!-- Mostrar las preguntas -->
				  		 	<v-card-text class="text-center pt-0">

				  		 		<v-switch label="Ver respuestas" v-model="pregunta.ver"></v-switch>

				  		 		<!-- Preguntas no ver respuesta -->
				  		 		<v-chip-group
						        v-model="pregunta.eleccion"
						        active-class="primary--text text--accent-4"
						        column
						        v-if="!pregunta.ver"
										required
						      >
						        <v-chip :value="1">
						          a) {{ pregunta.valor1 }} 
						        </v-chip>

						        <v-chip :value="2">
						          b) {{ pregunta.valor2 }}
						        </v-chip>

						        <v-chip :value="3">
						          c) {{ pregunta.valor3 }}
						        </v-chip>

						        <v-chip :value="4">
						          d) {{ pregunta.valor4 }}
						        </v-chip>
						      </v-chip-group>

						      <!-- Ver las respuestas -->
							    <v-chip-group
						        v-model="pregunta.eleccion"
						        active-class="primary--text text--accent-4"
						        column
										required
										v-else
						      >
						        <v-chip :value="1" 
						        	:color="`${ pregunta.opcion_correcta == 1 ? 'green': ''}`" 
						        	:class="`${ pregunta.opcion_correcta == 1 ? 'white--text' : '' }`" 
						        >
						          a) {{ pregunta.valor1 }} 
						          <v-icon small right v-if="pregunta.opcion_correcta == 1">mdi-check</v-icon>
						        </v-chip>

						        <v-chip :value="2"
						        	:color="`${ pregunta.opcion_correcta ==  2 ? 'green': ''}`" 
						        	:class="`${ pregunta.opcion_correcta == 2 ? 'white--text' : '' }`" 
						        >
						          b) {{ pregunta.valor2 }}
						          <v-icon small right v-if="pregunta.opcion_correcta == 2">mdi-check</v-icon>
						        </v-chip>

						        <v-chip :value="3"
						        	:color="`${ pregunta.opcion_correcta ==  3 ? 'green': ''}`" 
						        	:class="`${ pregunta.opcion_correcta == 3 ? 'white--text' : '' }`" 
						        >
						          c) {{ pregunta.valor3 }}
						          <v-icon small right v-if="pregunta.opcion_correcta == 3">mdi-check</v-icon>
						        </v-chip>

						        <v-chip :value="4"
						        	:color="`${ pregunta.opcion_correcta ==  4 ? 'green': ''}`" 
						        	:class="`${ pregunta.opcion_correcta == 4 ? 'white--text' : '' }`" 
						        >
						          d) {{ pregunta.valor4 }}
						          <v-icon small right v-if="pregunta.opcion_correcta == 4">mdi-check</v-icon>
						        </v-chip>
						      </v-chip-group>
				  		 	</v-card-text>		
				  		</v-card>
				  	</v-col>
				  </v-row>

				  <v-speed-dial
			      top
			      left
			      fixed
			    >
			      <template v-slot:activator>
			        <v-btn
			          color="white"
			          fab
			          @click="parametros.estatus = false"
			        >
			          <v-icon color="primary">
			            mdi-close
			          </v-icon>
			        </v-btn>
			      </template>
			    </v-speed-dial>
				</v-card-text>
			</v-card>
		  
		</v-dialog>
	</v-container>
</template>
<script>
	// importar librerías
	import { mapGetters, mapActions } from 'vuex'

	// Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

	export default {
	  name: "dashboard-default",

	  props:['parametros'],

	  data: () => ({
	  }),

	  components: {
	    Alerta,
	    Loader
	  },

	  created ( ){
	  	console.log( this.parametros )
	  },

	  computed:{
	  	...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getRecurso' ])
	  },
	  
	};
</script>

<style scoped>
	.shadowCard{
		border-radius: 15px !important; 
		box-shadow: 0 20px 27px 0 rgba(0,0,0,0.1)  !important;
	}
	
	.colorCurso{
		color: #006093;
	}
</style>
